import { GlSprintf } from '@gitlab/ui';
import ProtectedBadge from '~/vue_shared/components/badges/protected_badge.vue';
import { __, s__, sprintf } from '~/locale';
import { localeDateFormat } from '~/lib/utils/datetime/locale_dateformat';
import { newDate } from '~/lib/utils/datetime_utility';
import PackageTags from '~/packages_and_registries/shared/components/package_tags.vue';
import { PACKAGE_TYPE_NUGET } from '~/packages_and_registries/package_registry/constants';
import { getPackageTypeLabel } from '~/packages_and_registries/package_registry/utils';
import MetadataItem from '~/vue_shared/components/registry/metadata_item.vue';
import TitleArea from '~/vue_shared/components/registry/title_area.vue';
import TimeAgoTooltip from '~/vue_shared/components/time_ago_tooltip.vue';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
export default {
    name: 'PackageTitle',
    components: {
        TitleArea,
        GlSprintf,
        PackageTags,
        MetadataItem,
        TimeAgoTooltip,
        ProtectedBadge
    },
    mixins: [
        glSlotsMixin
    ],
    inject: [
        'isGroupPage'
    ],
    i18n: {
        lastDownloadedAt: s__('PackageRegistry|Last downloaded %{dateTime}'),
        packageInfo: __('v%{version} published %{timeAgo}'),
        badgeProtectedTooltipText: s__('PackageRegistry|A protection rule exists for this package.')
    },
    props: {
        packageEntity: {
            type: Object,
            required: true
        }
    },
    computed: {
        packageLastDownloadedAtDisplay () {
            return sprintf(this.$options.i18n.lastDownloadedAt, {
                dateTime: localeDateFormat.asDate.format(newDate(this.packageEntity.lastDownloadedAt))
            });
        },
        packageTypeDisplay () {
            return getPackageTypeLabel(this.packageEntity.packageType);
        },
        packagePipeline () {
            return this.packageEntity.pipelines?.nodes[0];
        },
        packageIcon () {
            if (this.packageEntity.packageType === PACKAGE_TYPE_NUGET) {
                return this.packageEntity.metadata?.iconUrl || null;
            }
            return null;
        },
        hasTagsToDisplay () {
            return Boolean(this.packageEntity.tags?.nodes && this.packageEntity.tags?.nodes.length);
        },
        showBadgeProtected () {
            return Boolean(this.packageEntity?.protectionRuleExists);
        }
    }
};
